import { devMode } from 'shared-kernel/helpers';

const getCss = c => `display: inline-flex; width: 12px; background-color: ${c}; color: ${c}`;

export default {
    i: (...input) => devMode && console.log(`%c.`, getCss('#0284c7'), ...input),
    w: (...input) => devMode && console.log(`%c.`, getCss('#f59e0b'), ...input),
    s: (...input) => devMode && console.log(`%c.`, getCss('#10b981'), ...input),
    e: (...input) => devMode && console.log(`%c.`, getCss('#f43f5e'), ...input),
    l: (...input) => devMode && console.log(`%c.`, getCss('#64748b'), ...input),
}
